import React from 'react';

function MapBubble(props) {
    const className = props.className;
    const fill = props.fill;
    const stroke = props.stroke;
    const strokeWidth = props.strokeWidth;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="28" 
            height="34" 
            viewBox="0 0 28 34" 
            fill="none"
            className={className}
        >
            <path 
                d="M14.2414 33L14.1241 33.2208L14.2414 33.2831L14.3586 33.2208L14.2414 33ZM14.2414 33C14.3586 33.2208 14.3588 33.2207 14.3589 33.2206L14.3595 33.2203L14.3616 33.2192L14.3694 33.215L14.3991 33.199C14.4249 33.1848 14.463 33.1639 14.5123 33.1362C14.6111 33.0809 14.7551 32.9986 14.9381 32.8899C15.3039 32.6724 15.8254 32.3493 16.4507 31.9249C17.7009 31.0765 19.3682 29.822 21.0365 28.1973C24.3681 24.9528 27.7328 20.2024 27.7328 14.2414C27.7328 6.7903 21.6925 0.75 14.2414 0.75C6.7903 0.75 0.75 6.7903 0.75 14.2414C0.75 20.2024 4.11467 24.9528 7.44627 28.1973C9.11452 29.822 10.7819 31.0765 12.032 31.9249C12.6573 32.3493 13.1788 32.6724 13.5447 32.8899C13.7276 32.9986 13.8717 33.0809 13.9704 33.1362C14.0198 33.1639 14.0578 33.1848 14.0837 33.199L14.1133 33.215L14.1211 33.2192L14.1232 33.2203L14.1238 33.2206C14.124 33.2207 14.1241 33.2208 14.2414 33Z" 
                fill={fill} 
                stroke={stroke} 
                strokeWidth={strokeWidth}
            />
        </svg>
    )
};

export default MapBubble;